import styles from '@styles/components/product-inner/recipes-list/index.module.scss';
import SILink from "@components/link/silink";
import Link from "next/link";

// @ts-ignore
export const RecipesList = ({relatedRecipes}) => {

    return (
        <section className={styles.recipes}>
            <span className={'recipes_you_love'}>recipes you’ll love</span>
            {
                relatedRecipes && relatedRecipes.length > 0 ?
                    <div className={'recipes_list'}>
                        {
                            relatedRecipes.map((item: any, index: number) => {
                                return (<Link key={'all-recipes-' + index}
                                              href={`/all-recipes/${item.attributes.Link}`}>
                                    <div className={`img_container ${index == 1 ? 'active' : ''}`}>
                                        <img
                                            src={index != 1 ? item.attributes.Large_Image.data.attributes.url : item.attributes.Small_Image.data.attributes.url}
                                            alt={index != 1 ? item.attributes.Large_Image.data.attributes.alternativeText : item.attributes.Small_Image.data.attributes.alternativeText}/>
                                        <div/>
                                    </div>
                                    <div className={'title_tags'}>
                                        <span>{item.attributes.Banner_Title}</span>
                                        <span className={'tags'}>{item.attributes.Categories.join(" / ")}</span>
                                    </div>
                                </Link>)
                            })
                        }
                    </div> : <></>
            }
            <div className={'get_inspired_box'}>
                <img src='/assets/images/decorations/product_inner/product_inner_page_get_inspired.webp' alt={'get inspired'}/>
                <div className={'get_inspired'}>
                    <span>get inspired</span>
                    <p>Bring dynamic flavors and better-for-you ingredients to the table with recipes carefully crafted
                        by SIDR chefs test.</p>
                    <SILink href={'/all-recipes'} classes={''}>explore</SILink>
                </div>
            </div>
        </section>
    )
}
